<template>
  <!-- table -->
  <xm-flex>
    <xm-flex-item>
      <xm-search-box>
        <el-select v-model="search.templateGroupId" placeholder="请选择类型" size="small" @change="searchData">
          <el-option v-for="item in selector.templateGroup" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="add">新增模板</el-button>
      </xm-search-box>
    </xm-flex-item>
    <xm-flex-item><xm-total-count>{{`名片模板列表(${totalCount}条)`}}</xm-total-count></xm-flex-item>
    <xm-flex-item :flex="1">
      <xm-table-plus :query-data="queryData" ref="table">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="templateGroup.name" label="类型" width="120"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column label="尺寸" width="200">
          <template #default="scope">名片：{{`${scope.row.width}px*${scope.row.height}px`}}，消息：{{`${scope.row.msgWidth}px*${scope.row.msgHeight}px`}}</template>
        </el-table-column>
        <el-table-column label="示例" width="82">
          <template #default="scope">
            <el-image style="width: 60px; height: 60px" :src="scope.row.sampleImage" fit="contain" :preview-src-list="[scope.row.sampleImage]" :initial-index="1"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="背景" width="82">
          <template #default="scope">
            <el-image style="width: 60px; height: 60px" :src="scope.row.background" fit="contain" :preview-src-list="[scope.row.background]" :initial-index="1"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="消息示例" width="82">
          <template #default="scope">
            <el-image style="width: 60px; height: 60px" :src="scope.row.msgSampleImage" fit="contain" :preview-src-list="[scope.row.msgSampleImage]" :initial-index="1"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="消息背景" width="82">
          <template #default="scope">
            <el-image style="width: 60px; height: 60px" :src="scope.row.msgBackground" fit="contain" :preview-src-list="[scope.row.msgBackground]" :initial-index="1"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="70">
          <template #default="scope">
            <el-tag type="primary" size="small" v-if="scope.row.flag === 1">显示</el-tag>
            <el-tag type="info" size="small" v-else>隐藏</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template #default="scope">
            <el-button type="text" size="small" @click="modify(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="edit(scope.row.posterTemplateId)">编辑内容</el-button>
            <el-button type="text" size="small" @click="msgEdit(scope.row.msgPosterTemplateId)">编辑消息内容</el-button>
            <el-button type="text" size="small" @click="setFlag(scope.row.id, scope.row.flag)">{{scope.row.flag===1?'隐藏':'显示'}}</el-button>
            <el-dropdown @command="handleCommand">
              <el-button type="text" size="small" class="el-dropdown-link">更多</el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :command="{name: 'move', id: scope.row.id, action: 'up'}" v-if="!scope.row._isFirst">上移</el-dropdown-item>
                  <el-dropdown-item :command="{name: 'move', id: scope.row.id, action: 'down'}" v-if="!scope.row._isLast">下移</el-dropdown-item>
                  <el-dropdown-item :command="{name: 'move', id: scope.row.id, action: 'top'}" v-if="!scope.row._isFirst">置顶</el-dropdown-item>
                  <el-dropdown-item :command="{name: 'move', id: scope.row.id, action: 'bottom'}" v-if="!scope.row._isLast">置底</el-dropdown-item>
                  <el-dropdown-item :command="{name: 'clear', id: scope.row.id}">删除</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </xm-table-plus>
    </xm-flex-item>
  </xm-flex>
  <!-- dialog -->
  <el-dialog v-model="dialog.visible" :title="dialog.title" destroy-on-close>
    <el-form ref="ruleForm" :model="dialog.data" label-width="auto">
      <!-- 名称 -->
      <el-form-item label="名称" prop="name" :rules="[
        {required:true, message: '名称不能为空',trigger: 'blur'}
      ]">
        <el-input v-model="dialog.data.name" size="small" maxlength="128" clearable></el-input>
      </el-form-item>
      <!-- 类型 -->
      <el-form-item label="类型" prop="templateGroupId" :rules="[
        {required:true, message: '类型不能为空',trigger: 'blur'}
      ]">
        <el-select v-model="dialog.data.templateGroupId" placeholder="请选择类型" size="small" clearable>
          <el-option v-for="item in selector.templateGroup" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 宽 -->
      <el-form-item label="名片宽(px)" prop="width" :rules="[
        {required:true, message: '宽不能为空',trigger: 'blur'}
      ]">
        <el-input v-model="dialog.data.width" size="small" type="number" clearable></el-input>
      </el-form-item>
      <!-- 高 -->
      <el-form-item label="名片高(px)" prop="height" :rules="[
        {required:true, message: '高不能为空',trigger: 'blur'}
      ]">
        <el-input v-model="dialog.data.height" size="small" type="number" clearable></el-input>
      </el-form-item>
      <!-- 封面图片 -->
      <el-form-item label="封面图" prop="sampleImage" :rules="[
        {required: !dialog.data.cardPosterTemplateId, message: '封面图不能为空', trigger: 'blur'}
      ]">
        <el-upload action="" :http-request="uploadImage" :on-exceed="exceedImage" :limit="1" list-type="picture">
          <el-button size="small" type="default">上传图片</el-button>
        </el-upload>
      </el-form-item>
      <!-- 背景图片 -->
      <el-form-item label="背景图" prop="background" :rules="[
        {required: !dialog.data.cardPosterTemplateId, message: '背景图不能为空', trigger: 'blur'}
      ]">
        <el-upload action="" :http-request="uploadBackground" :on-exceed="exceedImage" :limit="1" list-type="picture">
          <el-button size="small" type="default">上传图片</el-button>
        </el-upload>
      </el-form-item>
      <!-- 宽 -->
      <el-form-item label="消息宽(px)" prop="msgWidth" :rules="[
        {required:true, message: '宽不能为空',trigger: 'blur'}
      ]">
        <el-input v-model="dialog.data.msgWidth" size="small" type="number" clearable></el-input>
      </el-form-item>
      <!-- 高 -->
      <el-form-item label="消息高(px)" prop="msgHeight" :rules="[
        {required:true, message: '高不能为空',trigger: 'blur'}
      ]">
        <el-input v-model="dialog.data.msgHeight" size="small" type="number" clearable></el-input>
      </el-form-item>
      <!-- 消息封面图片 -->
      <el-form-item label="消息封面图" prop="msgSampleImage" :rules="[
        {required: !dialog.data.cardPosterTemplateId, message: '封面图不能为空', trigger: 'blur'}
      ]">
        <el-upload action="" :http-request="msgUploadImage" :on-exceed="exceedImage" :limit="1" list-type="picture">
          <el-button size="small" type="default">上传图片</el-button>
        </el-upload>
      </el-form-item>
      <!-- 消息背景图片 -->
      <el-form-item label="消息背景图" prop="msgBackground" :rules="[
        {required: !dialog.data.cardPosterTemplateId, message: '背景图不能为空', trigger: 'blur'}
      ]">
        <el-upload action="" :http-request="msgUploadBackground" :on-exceed="exceedImage" :limit="1" list-type="picture">
          <el-button size="small" type="default">上传图片</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialog.visible = false" size="small">取消</el-button>
      <el-button type="primary" @click="confirm" size="small">确定</el-button>
    </template>
  </el-dialog>
  <!-- drawer -->
  <el-drawer v-model="drawer.visible" title="编辑内容项" :size="900" :before-close="beforClose" destroy-on-close>
    <xm-flex>
      <xm-flex-item :flex="1">
        <poster-template-editor :poster-template-id="drawer.id" />
      </xm-flex-item>
    </xm-flex>
  </el-drawer>
  <el-drawer v-model="msgDrawer.visible" title="编辑内容项" :size="900" :before-close="beforClose" destroy-on-close>
    <xm-flex>
      <xm-flex-item :flex="1">
        <poster-template-editor :poster-template-id="msgDrawer.id" />
      </xm-flex-item>
    </xm-flex>
  </el-drawer>
</template>
<script>
import { ElButton, ElDialog, ElSelect, ElOption, ElTableColumn, ElForm, ElFormItem, ElInput, ElDropdown, ElDropdownItem, ElDropdownMenu, ElUpload, ElImage, ElTag, ElDrawer } from 'element-plus'
import axios from '@/common/utils/axios'
import { onMounted, reactive, ref } from 'vue'
import type from '@/common/utils/type'
import upload from '@/common/utils/upload'
import PosterTemplateEditor from '../../components/poster-template-editor'

function table () {
  const search = reactive({
    templateGroupId: ''
  })
  const selector = reactive({
    templateGroup: []
  })
  /**
     * 表单信息
     */
  const table = ref(null)
  const totalCount = ref(0)
  /**
     * 查询表单列表
     */
  const queryData = (page, pageSize) => {
    return new Promise((resolve) => {
      axios('/manager/card/poster/template/list', {
        templateGroupId: search.templateGroupId,
        page,
        pageSize
      })
        .then(res => {
          totalCount.value = res.totalCount
          table.value.judgePosition(res.cardPosterTemplateList, res.totalCount)
          resolve({
            list: res.cardPosterTemplateList,
            totalCount: res.totalCount
          })
        }).catch(_ => { })
    })
  }
  /**
   * 搜索模板
   */
  const searchData = () => {
    table.value.reload()
  }
  /**
     * 查询枚举--模板类型
     */
  const queryType = () => {
    return new Promise((resolve) => {
      axios('/manager/template/group/list/all', { type: type().templateGroupType.card })
        .then(res => {
          res.templateGroupList.forEach(item => {
            selector.templateGroup.push(item)
          })
          search.templateGroupId = res.templateGroupList[0].id
          resolve()
        }).catch(_ => { })
    })
  }
  onMounted(async () => {
    await queryType()
    table.value.reload()
  })

  return {
    search,
    selector,
    table,
    queryData,
    totalCount,
    searchData
  }
}

function dialog () {
  const ruleForm = ref(null)
  const dialog = reactive({
    visible: false,
    title: '',
    data: {}
  })
  return {
    ruleForm,
    dialog
  }
}

function drawer () {
  const drawer = reactive({
    id: 0,
    visible: false
  })
  return {
    drawer
  }
}

function msgDrawer () {
  const msgDrawer = reactive({
    id: 0,
    visible: false
  })
  return {
    msgDrawer
  }
}

function operation (t, d, dr, msgDr) {
  /**
     * 新增
     */
  const add = () => {
    d.dialog.visible = true
    d.dialog.title = '新增模板'
    d.dialog.data = {
      cardPosterTemplateId: '',
      templateGroupId: t.search.templateGroupId,
      name: ''
    }
  }
  /**
     * 修改
     */
  const modify = (row) => {
    d.dialog.visible = true
    d.dialog.title = '修改模板'
    d.dialog.data = {
      cardPosterTemplateId: row.id,
      templateGroupId: row.templateGroup.id,
      name: row.name,
      width: row.width,
      height: row.height,
      sampleImage: row.sampleImage,
      background: row.background,
      msgWidth: row.msgWidth,
      msgHeight: row.msgHeight,
      msgSampleImage: row.msgSampleImage,
      msgBackground: row.msgBackground
    }
  }
  /**
   * 编辑内容项
   */
  const edit = (id) => {
    dr.drawer.id = id
    dr.drawer.visible = true
  }
  /**
   * 编辑内容项
   */
  const msgEdit = (id) => {
    msgDr.msgDrawer.id = id
    msgDr.msgDrawer.visible = true
  }
  /**
   * 保存名片模板
   */
  const confirm = () => {
    d.ruleForm.value.validate(valid => {
      if (!valid) {
        return
      }
      submit()
    })
  }
  const submit = () => {
    axios('/manager/card/poster/template/save', d.dialog.data)
      .then(res => {
        window.$message({
          message: '操作成功',
          type: 'success'
        })
        d.dialog.visible = false
        t.table.value.reloadCurrent()
      }).catch(_ => { })
  }
  /**
   * 更改状态
   */
  const setFlag = (id, flag) => {
    axios('/manager/card/poster/template/flag/set', {
      cardPosterTemplateId: id,
      flag: flag === 1 ? 0 : 1
    }).then(res => {
      window.$message({
        message: '操作成功',
        type: 'success'
      })
      t.table.value.reloadCurrent()
    })
  }
  /**
     * 指令列表
     */
  const handleCommand = (command) => {
    commandList[command.name](command.id, command.action)
  }
  const commandList = {
    clear: (id) => { // 删除
      window.$confirm('是否确认删除').then(() => {
        del(id)
      }).catch(_ => { })
    },
    move: (id, action) => {
      axios('/manager/card/poster/template/move', {
        cardPosterTemplateId: id,
        move: action
      }).then(res => {
        window.$message({
          message: '操作成功',
          type: 'success'
        })
        t.table.value.reload()
      })
    }
  }
  const del = (id) => {
    axios('/manager/card/poster/template/del', {
      cardPosterTemplateId: id
    })
      .then(res => {
        window.$message({
          message: '操作成功',
          type: 'success'
        })
        t.table.value.reloadCurrent()
      }).catch(_ => { })
  }
  /**
   * 上传封面图片
   */
  const uploadImage = ({ file }) => {
    upload(file, '0', (url) => {
      d.dialog.data.sampleImage = url
    })
  }
  /**
   * 超出数量提示
   */
  const exceedImage = () => {
    window.$message({
      message: '图片超出数量，请删除后上传',
      type: 'error'
    })
  }
  /**
   * 上传背景图片
   */
  const uploadBackground = ({ file }) => {
    upload(file, '0', (url) => {
      d.dialog.data.background = url
    })
  }
  /**
   * 上传消息封面图片
   */
  const msgUploadImage = ({ file }) => {
    upload(file, '0', (url) => {
      d.dialog.data.msgSampleImage = url
    })
  }
  /**
   * 上传消息背景图片
   */
  const msgUploadBackground = ({ file }) => {
    upload(file, '0', (url) => {
      d.dialog.data.msgBackground = url
    })
  }
  return {
    add,
    modify,
    edit,
    msgEdit,
    confirm,
    setFlag,
    handleCommand,
    uploadImage,
    exceedImage,
    uploadBackground,
    msgUploadImage,
    msgUploadBackground
  }
}

export default {
  components: { ElButton, ElDialog, ElSelect, ElOption, ElTableColumn, ElForm, ElFormItem, ElInput, ElDropdown, ElDropdownItem, ElDropdownMenu, ElUpload, ElImage, ElTag, ElDrawer, PosterTemplateEditor },

  setup () {
    const t = table()
    const d = dialog()
    const dr = drawer()
    const msgDr = msgDrawer()
    const o = operation(t, d, dr, msgDr)
    return {
      ...t,
      ...d,
      ...dr,
      ...msgDr,
      ...o
    }
  }
}
</script>
<style lang="scss" scoped>
.button-group {
  text-align: right;
}
:deep .tox-tinymce{
  height: calc(100% - 20px) !important;
}
.el-dropdown .el-button {
  margin-left: 10px;
}
</style>
